export { default } from 'pages/account/payment-methods';
